import type { StepProps } from 'antd';
import { Button, Col, Row } from 'antd';

import { amplitudeTrack } from 'app/utils/track/amplitude';

type VCCModalFooterProps = {
  setCurrentStep: (step: number) => void;
  currentStep: number;
  steps: StepProps[];
  onSubmit: () => Promise<void>;
  activateButtonLoading: boolean;
};

export const VCCModalFooter = ({
  setCurrentStep,
  currentStep,
  steps,
  onSubmit,
  activateButtonLoading,
}: VCCModalFooterProps) => {
  const handlePreviousStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleNextStep = async () => {
    setCurrentStep(currentStep + 1);
    amplitudeTrack('Click on next step', {
      step: steps[currentStep + 1].title as string,
    });
  };

  return (
    <Row justify={'space-between'}>
      <Col>
        {currentStep > 0 && !activateButtonLoading && (
          <Button type="default" onClick={handlePreviousStep}>
            Back
          </Button>
        )}
      </Col>
      <Col>
        {currentStep !== steps.length - 1 && (
          <Button onClick={handleNextStep}>Next</Button>
        )}
        {currentStep === steps.length - 1 && (
          <Button
            type="primary"
            onClick={onSubmit}
            loading={activateButtonLoading}
          >
            Activate
          </Button>
        )}
      </Col>
    </Row>
  );
};
